export const messages =  {
  en: {
    supplierCoupon: {
      title: 'Supplier Coupon Management',
      searchConditions: 'Search Conditions',
      couponInfo: 'Coupon Information',
      name: 'Name',
      businessId: 'Business ID',
      supplier: 'Supplier',
      thirdPartyId: 'Third-party ID',
      price: 'Price',
      remark: 'Remark',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      cancel: 'Cancel',
      deleteConfirm: 'Are you sure to delete this coupon?',
      deleteTitle: 'Confirm Operation',
      required: 'Required',
      addTitle: 'Add Coupon',
      editTitle: 'Edit Coupon',
      search: 'Search',
      noData: 'No data',
      supplierRequired: 'Please select a supplier first'
    }
  },
  zh: {
    supplierCoupon: {
      title: '供应商优惠券管理',
      searchConditions: '查询条件',
      couponInfo: '优惠券信息',
      name: '名称',
      businessId: '业务ID',
      supplier: '供应商',
      thirdPartyId: '三方ID',
      price: '售价',
      remark: '备注',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirm: '确认',
      cancel: '取消',
      deleteConfirm: '确定删除优惠券？',
      deleteTitle: '请确认您的操作',
      required: '必填',
      addTitle: '添加优惠券',
      editTitle: '修改优惠券',
      search: '查询',
      noData: '暂无数据',
supplierRequired: '請先選擇供應商'
    }
  },
  'zh-TW': {
    supplierCoupon: {
      title: '供應商優惠券管理',
      searchConditions: '查詢條件',
      couponInfo: '優惠券信息',
      name: '名稱',
      businessId: '業務ID',
      supplier: '供應商',
      thirdPartyId: '三方ID',
      price: '售價',
      remark: '備註',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '刪除',
      confirm: '確認',
      cancel: '取消',
      deleteConfirm: '確定刪除優惠券？',
      deleteTitle: '請確認您的操作',
      required: '必填',
      addTitle: '添加優惠券',
      editTitle: '修改優惠券',
      search: '查詢',
      noData: '暫無數據',
      supplierRequired: '請先選擇供應商'
    }
  }
}